import React from 'react'
import styled from 'styled-components'
import { Modal } from 'fbk-components'
import { Close as CloseIcon } from 'assets/svg'
import Slider from './Slider'
import { SliderProps } from './types'

const StyledModal = styled(Modal)`
  background: rgba(0, 0, 0, 0.85);

  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 32px;
    left: 0;
    height: 100%;
    background: none;
  }

  .close-wrap {
    position: fixed;
    top: 0;
    right: 0;
    z-index: ${({ theme }) => theme.zIndex.header};
    width: 60px;
    height: 60px;
    padding: 0;
    color: #fff;
    background: rgba(0, 0, 0, 0.8);

    .close {
      width: inherit;
      height: inherit;
      line-height: 0;
      color: #fff;
    }
  }

  @media (min-width: 768px) {
    .close-wrap {
      top: 40px;
      right: 40px;
    }
  }

  @media (min-width: 1200px) {
    .modal {
      bottom: 0;
    }
  }
`

const StyledSlider = styled(Slider)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .carousel {
    flex: 1;
  }

  .slick-slider,
  .slick-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .slick-list {
    width: 100%;
    margin-bottom: -8px;
  }

  .slick-track {
    display: flex;
    align-items: center;
  }

  .image-wrap {
    max-height: 100%;
  }

  @media (min-width: 768px) {
    justify-content: center;

    .left-area,
    .right-area {
      position: fixed;
    }

    .left-area {
      padding-left: 40px;
    }

    .right-area {
      padding-right: 40px;
    }

    .next-button,
    .prev-button {
      width: 60px;
      height: 60px;
      color: #fff;
      background: rgba(0, 0, 0, 0.8);
    }
  }

  @media (min-width: 1200px) {
    .prev-button,
    .next-button {
      opacity: 1;
    }

    .markers {
      display: none;
    }
  }
`

interface Props extends SliderProps {
  isOpen: boolean
  closeModal: () => void
}

const SliderInModal = ({ isOpen, closeModal, ...rest }: Props) => {
  return (
    <StyledModal isOpen={isOpen} onClose={closeModal} isFullScreen>
      {() => {
        return (
          <>
            <div className="close-wrap">
              <button type="button" onClick={closeModal} className="close">
                <CloseIcon />
              </button>
            </div>
            <StyledSlider isInModal {...rest} />
          </>
        )
      }}
    </StyledModal>
  )
}

export default SliderInModal
